export default __webpack_public_path__ + "static/media/176.1a946d5e.png";